import axios from "axios";
import { APIURL } from "../../../../APIHandler/APIURL"
import { Headers } from "../../../../APIHandler/HeaderAPI";
import { reloadHandler } from "../../../../utlis/utlis";
import { Create_Speaker_failure, Create_Speaker_request, Create_Speaker_success } from "../../../Reducer/Admin/Speakers/craetespeakerSlice";
import { GetSpeakerAPI } from "./GetSpeakers";
import { Clear_Get_ID_speakers_Check } from "../../../Reducer/Admin/Speakers/GetIdSpeakerSlice";

export const EditSpeakerAPI = (payload,id,editid) => async (dispatch, getState) => {
    // const eventItemId=localStorage.getItem("eventItemId")
    const auth_token = localStorage.getItem("auth_token")
    const admineventid = localStorage.getItem("admineventid")
    dispatch(Create_Speaker_request())
    try {
        const { data } = await axios.post(`${APIURL.Editspeakers}/${editid}`,payload, {
            headers: {
                "host-url": Headers?.["host-url"],
                "language": Headers?.language,
            "event-slug":Headers?.["event-slug"],
                "Content-type": "application/x-www-form-urlencoded",
                Authorization: `Bearer ${auth_token}`
            },
        })
      
        dispatch(Create_Speaker_success(data))
        if(id){

            dispatch(GetSpeakerAPI(id))
        }else{

            dispatch(GetSpeakerAPI(admineventid))
        }
        dispatch(Clear_Get_ID_speakers_Check())
    } catch (error) {
        reloadHandler(error?.response?.status)
        dispatch(Create_Speaker_failure(error?.response?.data))
    }
}

